import { get } from "lodash"
import { VIEW_TYPES } from "helpers/base"

export const getCurrency = (_, props) => props.currency
export const getPositionSets = (_, props) => props.positionSets
export const getIsActive = (_, props) => get(props, "viewType") === VIEW_TYPES.ACTIVE
